import { FC } from 'react';
import styled from 'styled-components';
import { IconButton, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const BackButton = styled(IconButton)`
  position: absolute;
  left: ${({ theme }) => theme.spacing(2)};
  top: ${({ theme }) => theme.spacing(4.5)}; // To align with the title
`;

type Props = { goToPreviousStep: () => void };

const ResetPasswordBackButton: FC<Props> = ({ goToPreviousStep }) => (
  <Tooltip title="Back" arrow placement="top" enterDelay={1000}>
    <BackButton onClick={goToPreviousStep}>
      <ArrowBack color="primary" />
    </BackButton>
  </Tooltip>
);

export default ResetPasswordBackButton;
